import { createMediaButton } from "../create-media-button.js";
import { CastButtonCore, CastButtonDataAttrs } from "@videojs/core";
import { selectRemotePlayback } from "@videojs/core/dom";
//#region src/ui/cast-button/component.tsx
/** A button that toggles casting to a remote device. */
const CastButton = createMediaButton({
	displayName: "CastButton",
	core: CastButtonCore,
	stateAttrMap: CastButtonDataAttrs,
	selector: selectRemotePlayback,
	action: (core, state) => core.toggle(state),
	isSupported: (state) => !state.hidden
});
//#endregion
export { CastButton };

//# sourceMappingURL=component.js.map